import { DEFAULT_DOWNLOADS_GET_LIMIT } from "shared/imports/sharedConstants"

const swalContents = {
    submitIssueFailure: {
        icon: "error",
        text: "There was an error creating your issue, please try again.",
        title: "Error",
    },
    submitIssueAdditionalFieldsFailure: {
        icon: "error",
        text: "Some fields in your issue might not have been saved properly, you may edit the issue to fix this.",
        title: "Error",
    },
    deleteIssueConfirm: {
        title: "Archive Issue?",
        text: "You will no longer be able to access this issue.",
        icon: "warning",
        buttons: {
            cancel: true,
            confirm: {
                text: "Archive",
            },
        },
    },
    deleteListConfirm: {
        title: "Delete List?",
        text: "This will completely delete this list, it will not be able to be recovered.",
        icon: "warning",
        buttons: {
            cancel: true,
            confirm: {
                text: "Delete",
            },
        },
    },
    // a little bit of cross-contamination with new-list, maybe move this up to the projects-new level?
    downloadPDFInfo: {
        title: "Downloading...",
        text: `Your PDF download for the first ${DEFAULT_DOWNLOADS_GET_LIMIT} items in this list has begun. Check your inbox in the next few minutes for a link.`,
        icon: "success",
    },
    formValidationFailed: {
        icon: "error",
        title: "Missing fields",
        text: "Some required fields are missing or do not have proper values. Please double check the form.",
    },
}

export default swalContents
